/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_MarkingInputs */

const en_samples_edit_marking = /** @type {(inputs: Samples_Edit_MarkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marking...`)
};

const es_samples_edit_marking = /** @type {(inputs: Samples_Edit_MarkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcando...`)
};

/**
* | output |
* | --- |
* | "Marking..." |
*
* @param {Samples_Edit_MarkingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_marking = /** @type {((inputs?: Samples_Edit_MarkingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_MarkingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_marking(inputs)
	return es_samples_edit_marking(inputs)
});